import React, { ReactNode, useCallback, useState } from 'react';

import { ButtonSizes, ConditionView, Icon, LinkAsButton, ServiceCard, SkeletonServiceCard } from '@/shared/ui';

import { UserServiceExternal } from '@/api/types';

import { ExternalServiceDetailsModal } from '../ExternalServiceDetailsModal/ExternalServiceDetailsModal';

interface ExternalServiceListProps {
  list: UserServiceExternal[] | null;
  isLoading: boolean;
}

const renderSkeletons = (): ReactNode[] =>
  Array.from({ length: 8 }, (_, idx) => idx).map((item) => <SkeletonServiceCard key={item} />);

export const ExternalServiceList = React.memo<ExternalServiceListProps>(({ list, isLoading }) => {
  const [selectedService, setSelectedService] = useState<Nullable<UserServiceExternal>>(null);

  const handleModalClose = useCallback(() => setSelectedService(null), []);

  const handleDetailsClick = useCallback((service: UserServiceExternal) => {
    setSelectedService(service);
  }, []);

  return (
    <>
      <div className="external-services-page__list">
        <ConditionView if={!isLoading} else={renderSkeletons()}>
          {list &&
            list.map((service) => (
              <ServiceCard
                key={service.name}
                title={service.name}
                icon={service.icon}
                subTitle={service.short_description}
                buttonLink={
                  <LinkAsButton size={ButtonSizes.LG} to={service.link}>
                    Перейти <Icon name="go_out" />
                  </LinkAsButton>
                }
                onDetailsClick={(): void => handleDetailsClick(service)}
              />
            ))}
        </ConditionView>
      </div>
      {!!selectedService && <ExternalServiceDetailsModal service={selectedService} onClose={handleModalClose} />}
    </>
  );
});
